import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=dfc1669c&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=dfc1669c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc1669c",
  null
  
)

export default component.exports